'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _execute = require('./execute');

Object.defineProperty(exports, 'execute', {
  enumerable: true,
  get: function get() {
    return _execute.execute;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/graphql/execution/index.js
 ** module id = 442
 ** module chunks = 0
 **/